import React, { Dispatch, SetStateAction } from 'react';
import { useIntl } from 'react-intl';

interface MoreButtonProps {
  displayAll: boolean;
  setDisplayAll: Dispatch<SetStateAction<boolean>>;
  displayedNum: number;
}

const MoreButton: React.FunctionComponent<MoreButtonProps> = ({
  displayedNum,
  setDisplayAll,
  displayAll,
}) => {
  const { formatMessage } = useIntl();
  return displayedNum ? (
    <div className="time-pill extra" key="extra" onClick={() => setDisplayAll(!displayAll)}>
      {displayAll
        ? `${formatMessage({ id: 'show_less' })}`
        : `${formatMessage({ id: 'show_all' })} +${displayedNum}`}
    </div>
  ) : null;
};

export default MoreButton;
